export default async function EditTaskApi(
  id, 
  name, 
  endDate, 
  startDate, 
  assignTo, 
  clickUpData = null
) {
  let res = "";
  try {
    const body = {
      name: name,
      taskEndDate: endDate,
      taskStartDate: startDate || null,
      assignedTo: assignTo || null,
    };

    // Add ClickUp fields if provided
    if (clickUpData) {
      body.clickupSpaceId = clickUpData.spaceId || null;
      body.clickupListId = clickUpData.listId || null;
      body.clickupAssigneeId = clickUpData.assigneeId || null;
      body.clickupPriority = clickUpData.priority || null;
      body.clickupTags = clickUpData.tags || null;
    }

    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/tasks/${id}/edit`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error edit task: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
